import {faArrowTrendUp, faComments, faPaperPlane} from '@fortawesome/pro-solid-svg-icons';

import {appRoute} from '../../../app-route';
import {LandingAdvantages} from '../../../component/landing/landing-advantages/landing-advantages';
import {ActivationPage} from '../../../layout/activation-page/activation-page';
import {Locale} from '../../../provider/locale/locale';

export function MultichatActivation(): JSX.Element {
    return (
        <ActivationPage
            breadCrumbList={[
                {
                    path: appRoute.omnichannel.path,
                    titleLangKey: 'CATEGORY_NAME__CHATWOOT',
                },
            ]}
            title={<Locale stringKey="CATEGORY_NAME__CHATWOOT" />}
        >
            <LandingAdvantages
                cardsData={[
                    {
                        titleLangKey: 'ACTIVATION_PAGE__MULTICHAT__ADVANTAGES_CARD_1__TITLE',
                        descriptionLangKey: 'ACTIVATION_PAGE__MULTICHAT__ADVANTAGES_CARD_1__DESCRIPTION',
                        icon: faComments,
                    },
                    {
                        titleLangKey: 'ACTIVATION_PAGE__MULTICHAT__ADVANTAGES_CARD_2__TITLE',
                        descriptionLangKey: 'ACTIVATION_PAGE__MULTICHAT__ADVANTAGES_CARD_2__DESCRIPTION',
                        icon: faPaperPlane,
                    },
                    {
                        titleLangKey: 'ACTIVATION_PAGE__MULTICHAT__ADVANTAGES_CARD_3__TITLE',
                        descriptionLangKey: 'ACTIVATION_PAGE__MULTICHAT__ADVANTAGES_CARD_3__DESCRIPTION',
                        icon: faArrowTrendUp,
                    },
                ]}
                titleLangKey="ACTIVATION_PAGE__MULTICHAT__ADVANTAGES__TITLE"
            />
        </ActivationPage>
    );
}
